const getCreditCardTokens = (action) => action.entities.creditCardTokens;

export default function creditCardTokensReducer(state = {}, action) {
  switch (action.type) {
    case "CREDIT_CARD_TOKENS_FETCHED":
      return getCreditCardTokens(action);
    case "CREDIT_CARD_TOKEN_UPDATED": {
      const updated = getCreditCardTokens(action);
      const hasNewDefault = Object.values(updated).some((t) => t.default);
      const base = hasNewDefault
        ? Object.fromEntries(Object.entries(state).map(([id, t]) => [id, { ...t, default: false }]))
        : state;
      return { ...base, ...updated };
    }
    case "CREDIT_CARD_TOKEN_DELETED": {
      const remaining = { ...state };
      delete remaining[action.id];
      return remaining;
    }
    default:
      return state;
  }
}
